export default {
  snapshots: [],
  snapshotById: {},
  totalItems: 0,
};
